import React, { useContext } from "react"
import { Link } from "react-router-dom"
import { CurrentUserContext } from "../../../context/CurrentUserContext"
import { Button } from "../../ui/button"

import QuarterCounterCard from "./QuarterCounterCard"
import GridCard from "./GridCard"
import DocumentComplianceSection from "./DocumentComplianceSection"
import CardSection from "./CardSection"

import { useProviderLayout } from "./hooks/useProviderLayout"
import { useQuarterState } from "./hooks/useQuarterState"
import { useEmployeeStatus } from "./hooks/useEmployeeStatus"
import { useHoursCompleted } from "./hooks/useHoursCompleted"

const ProviderDataSummary: React.FC = () => {
  const { currentUser } = useContext(CurrentUserContext)
  const { display } = useProviderLayout(currentUser)
  const { year, quarter, timeline, calLoading } = useQuarterState()

  const username = currentUser?.LoginName

  const { status: employeeStatus } = useEmployeeStatus(username, year, quarter)

  const hoursEnabled = !!username && !!year && display.BillableTable
  const { hoursProgress, loading: hoursLoading } = useHoursCompleted(
    username, year, quarter, employeeStatus, hoursEnabled
  )

  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-12 flex justify-end">
        <Button asChild>
          <Link to="/provider-data">View Full Provider Data</Link>
        </Button>
      </div>

      <CardSection bordered={false}>
        {timeline && (
          <div className="col-span-12 lg:col-span-6">
            <QuarterCounterCard
              title="Quarter Count"
              quarterStart={timeline.quarterStart}
              quarterEnd={timeline.quarterEnd}
              loading={calLoading}
            />
          </div>
        )}

        {display.BillableTable && (
          <div className="col-span-12 lg:col-span-6">
            <GridCard
              title="Hours Summary"
              headers={["Prorated Required Hours", "Total Hours in Quarter", "Pace Percentage"]}
              data={hoursProgress ? [hoursProgress] : []}
              loading={hoursLoading}
            />
          </div>
        )}
      </CardSection>

      <DocumentComplianceSection username={username} display={display} />
    </div>
  )
}

export default ProviderDataSummary
